import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscribeLeads } from '../data/listeners/leads';
import { pipelineValue } from '../data/pipeline';

const peso = (n) => `₱${Math.round(n).toLocaleString()}`;

// Pipeline value summary (CRM revisions Task 4): Raw total (Σ lead value) and
// Weighted total (Σ value × stage probability), side by side. Computed over the
// active (non-archived) board, scoped to the manager salesman filter when set.
export default function PipelineValueBar({ ownerFilter = '' }) {
  const { tenantId, role, territoryIds } = useAuth();
  const [leads, setLeads] = useState([]);

  useEffect(() => subscribeLeads({ tenantId, role, territoryIds }, setLeads), [tenantId, role, territoryIds]);

  const { raw, weighted } = useMemo(() => {
    const active = leads.filter((l) => !l.archived && (!ownerFilter || l.ownerUid === ownerFilter));
    return pipelineValue(active);
  }, [leads, ownerFilter]);

  return (
    <div className="stat-row" style={{ gridTemplateColumns: 'repeat(2, 1fr)', marginBottom: 'var(--space-4)' }}>
      <div className="stat">
        <div className="n">{peso(raw)}</div>
        <div className="l">Pipeline value — raw total</div>
      </div>
      <div className="stat">
        <div className="n" style={{ color: 'var(--presto-success)' }}>{peso(weighted)}</div>
        <div className="l">Pipeline value — weighted (× stage probability)</div>
      </div>
    </div>
  );
}
